import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Feed from './Feed';
import ToastMessage from './ToastMessage';
import { useSelector } from 'react-redux';
import { getShouldShowMessageState } from '../store/selectors/getPromos';

const Promo = (props) => {
    const { type, portalTarget, trackingProps, styleName } = props;
    const shouldShowMessage = useSelector(getShouldShowMessageState);

    const renderContent = useCallback(() => {
        switch (type) {
            case 'feed':
                return <Feed {...props} trackingProps={trackingProps} />;
            case 'toast':
                return <ToastMessage shouldShowMessage={shouldShowMessage} type={type} styleName={styleName} {...props} portalTarget={portalTarget} trackingProps={trackingProps}/>;
            default:
                return null;
        }
    }, [type, portalTarget, trackingProps, styleName, props]);

    return renderContent();
};

Promo.propTypes = {
    type: PropTypes.string,
    portalTarget: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
    trackingProps: PropTypes.object,
    styleName: PropTypes.string
};

export default Promo;
